// @flow
import React from "react"
import { compose } from "react-apollo"
import { Prompt } from "react-router-dom"
import { Helmet } from "react-helmet"
import { Toolbar, Heading } from "../UI/Toolbar"
import { Page } from "../UI/Page"
import UserForm from "./UserForm"
import queries from "./queries"
import Loader from "../UI/Loader"
import type { UserFormViewProps } from "./types"
import handleSubmit from "./handleSubmit"
import { confirmDeletePath } from "./helpers"

type State = { isBlocking: boolean }

class UserFormView extends React.Component<UserFormViewProps, State> {
  constructor(props) {
    super(props)
    this.state = { isBlocking: false }
  }

  handleChange(e) {
    this.setState(() => ({ isBlocking: true }))
  }

  componentDidUpdate(prevProps, prevState) {
    const { details } = this.props
    if (
      prevProps.details &&
      prevProps.details.loading &&
      details &&
      !details.loading
    ) {
      this.setState(() => ({ isBlocking: false }))
    }
  }

  render() {
    const {
      createUser,
      updateUser,
      history: { push },
      match: { params: { id } },
      details
    } = this.props
    const { isBlocking } = this.state

    return (
      <Page>
        <Helmet>
          <title>
            {`Users - ${details
              ? `${details.user ? details.user.name : "Editing"}`
              : "New"}`}
          </title>
        </Helmet>
        <Prompt
          when={isBlocking}
          message={location =>
            `Are you sure you want to leave this form and lose any unsaved changes?`}
        />
        <Loader loading={details ? details.loading : false}>
          <Toolbar>
            <Heading>
              {id && details ? (
                `Editing: ${details.user ? details.user.name : ""}`
              ) : (
                "New User"
              )}
            </Heading>
          </Toolbar>
          <UserForm
            loading={details ? details.loading : true}
            initialValues={details ? details.user : { admin: true }}
            onSubmit={handleSubmit(id, createUser, updateUser, () => {
              this.setState(() => ({ isBlocking: false }))
              push("/admin/users")
            })}
            onChange={e => this.handleChange(e)}
            handleCancel={event => {
              event.preventDefault()
              push("/admin/users")
            }}
            handleDelete={async event => {
              event.preventDefault()
              await this.setState(() => ({
                isBlocking: false
              }))
              push(confirmDeletePath(id))
            }}
            isNew={id ? false : true}
            id={id}
          />
        </Loader>
      </Page>
    )
  }
}

export default compose(
  queries.withUserFormDetails,
  queries.mutateCreateUser,
  queries.mutateUpdateUser
)(UserFormView)



// WEBPACK FOOTER //
// ./src/Users/UserFormView.js